export const W_8BEN_E = "W-8BEN-E";
export const W_9 = "W-9";
export const W_8BEN = "W-8BEN";
export const NOT_SPECIFIED = "NOT_SPECIFIED";
